




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Button extends Vue {
  @Prop({ default: 'link' }) className?: string;
  @Prop({ default: '' }) readonly text?: string;
  @Prop({ default: false }) disabled?: boolean;

  clicked(event: any) {
    this.$emit('clicked', event);
  }
}
